import { render, staticRenderFns } from "./addShopCoupon.vue?vue&type=template&id=dc41f4c8"
import script from "./addShopCoupon.vue?vue&type=script&lang=js"
export * from "./addShopCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports